import React, {useState, useEffect} from 'react';
//Material-UI
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import Avatar from '@material-ui/core/Avatar';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/styles';
//Icons
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';

const useStyles = makeStyles(theme => ({
   root: {
      height: '100%'
   },
   content: {
      padding: theme.spacing(1)
   },
   image: {
      height: 48,
      width: 48
   },
   actions: {
      justifyContent: 'flex-end'
   },
   avatar: {
      //backgroundColor: "",
   },
   header: {
      textAlign: 'center',
      spacing: 20,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.h4,
      fontWeight: theme.typography.fontWeightMedium,
      //backgroundColor: theme.palette.background.paper,
      letterSpacing: '0.2px'
   }
}));
/*
Funciones y variables auxiliares globales
*/
const rteDefaultValue = {
   key: 'vacio',
   contenido: ''
};

const msgModalInicial = {
   open: false,
   mensaje: '',
   accionAceptar: false,
   aceptarLabel: 'Eliminar'
};
//Queries

const Herramientas = props => {
   const classes = useStyles();
   /**
    * Estados
    */ 

   const [msgModal, setMsgModal] = useState(msgModalInicial);
   function handleClose() {
      setMsgModal(msgModalInicial);
   }
   function handleOpen(nuevoMsg) {
      setMsgModal({...msgModal, open: true, mensaje: nuevoMsg});
   }
   /**
    * Funciones
    */

   return (
      <Card>
         <CardHeader
            title={
               <Typography component="p" color="textPrimary" variant="h5">
                  Herramientas para Soporte
               </Typography>
            }
            disableTypography={true}
            avatar={
               <Avatar className={classes.avatar}>
                  <BusinessCenterIcon />
               </Avatar>
            }
         />
         <Divider />
         <CardContent className={classes.content}>
            <Link href="https://anydesk.com/es">AnyDesk</Link>
         </CardContent>
         <Divider />
      </Card>
   );
};

export default Herramientas;
